<template>
  <v-btn
    small fab dark falt fixed
    right
    style="top: calc(54% + 100px)"
    class="setting-fab"
    color="black"
    @click="$emit('click', $event)"
  >
    <v-icon>mdi-hammer</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'Damage',
};
</script>

<style scoped>

</style>
